import { EducationalVideoItem, IEducationalVideoItem } from "../../models/educationalVideos";
import { JsonConverter } from "../JsonConverter";
import fileBasedEducationalVideosCatalog_Json from '../../../assets/data/educationalVideosCatalog.json';

/**
 * @function getEducationalVideoItemFromVideoId Searches through the Educational Videos Catalog for a video item with matching id
 */
export function getEducationalVideoItemFromVideoId(videoId: string): IEducationalVideoItem | undefined {
    // get the entire video catalog
    const educationalVideosCatalog_fromJsonFile: Array<IEducationalVideoItem> = JsonConverter.arrayFromJSONArray(EducationalVideoItem, fileBasedEducationalVideosCatalog_Json);

    // from the video catalog, get the video item we're going display on this page
    const videoItem: IEducationalVideoItem | undefined = educationalVideosCatalog_fromJsonFile.find(videoItem => videoItem.id === videoId);

  return videoItem;
}
